import { Spinner, styled } from '@arpeggi/ui'

const Root = styled('div', {})

const TwoColGrid = styled('div', {
  display: 'flex',
  alignItems: 'stretch',
  flexDirection: 'column',
  '@tablet': {
    flexDirection: 'row',
    '& > *': {
      flex: 1
    }
  },
  gap: '24px',
  marginBottom: '24px'
})

const StyledSpinner = styled(Spinner, {
  strokeWidth: '1.5px',
  width: '24px',
  height: '24px'
})

export const Details = { Root, TwoColGrid, Spinner: StyledSpinner }
